import { useAutoAnimate } from "@formkit/auto-animate/react"
import { DeleteCouponButton } from "src/checkout/components/DeleteCouponButton"
import { useCoupons } from "src/checkout/hooks/useCoupon"
import { NpIcon } from "src/components/np-design/components/NpIcon"

export const TopCouponLines = () => {
  const coupons = useCoupons()
  const [animationParent] = useAutoAnimate()

  if (!coupons.length) {
    return null
  }

  return (
    <div ref={animationParent} className="flex w-full flex-col gap-2">
      {coupons
        .sort((a, b) => a.code.localeCompare(b.code))
        .map((coupon) => {
          const amount = <div className="text-np-green text-right whitespace-nowrap">- {coupon.discountFormatted}</div>

          return (
            <div key={coupon.code} className="flex items-center justify-between gap-2">
              <div className="invisible min-w-0">{amount}</div>

              <div className="flex items-center gap-1">
                <div className="flex items-center gap-2">
                  <code className="text-np-green border-np-green25 flex items-center gap-1 rounded-full border py-1 pr-3 pl-2">
                    <NpIcon name="percent" className="size-6" />
                    {coupon.code.toUpperCase()}
                  </code>
                </div>

                <DeleteCouponButton code={coupon.code} />
              </div>

              {amount}
            </div>
          )
        })}
    </div>
  )
}
